import { FieldId } from '~/evifields/src/types/FieldId';
import { PilotId } from '~/types/PilotId';
import { SearchApi } from '~/types/SearchApi';

import { getPromptModelTargetEntities } from './getPromptModelTargetEntities';

export const getPromptModelFieldIds = async ({
  searchApi = 'pilot',
}: { searchApi?: SearchApi } = {}): Promise<Array<PilotId | FieldId>> => {
  const items = await getPromptModelTargetEntities({ searchApi });
  const useEvisearch = searchApi === 'evisearch';

  return useEvisearch
    ? items.map((item) => item.target_entity.id)
    : items.map((item) => Number(item.target_entity.id));
};
